// src/components/Products/Cardapio/services/api.js
import api from '../../../../services/api';

const authHeader = () => ({});

// ---------------- Restaurante ----------------
export const getRestaurante = async (restauranteId) => {
  const res = await api.get('/cardapio/restaurante', {
    headers: authHeader(),
    // se vier pela URL (?restauranteId=), enviamos por querystring
    params: restauranteId ? { restauranteId } : undefined,
  });
  return res.data;
};

// ---------------- Cardápios ----------------
export const listCardapios = async () => {
  const res = await api.get('/cardapio/cardapios', { headers: authHeader() });
  return res.data;
};

export const getCardapio = async (id) => {
  const res = await api.get(`/cardapio/cardapios/${id}`, { headers: authHeader() });
  return res.data;
};

export const saveCardapio = async (data) => {
  if (data.id) {
    const res = await api.put(`/cardapio/cardapios/${data.id}`, data, { headers: authHeader() });
    return res.data;
  }
  const res = await api.post('/cardapio/cardapios', data, { headers: authHeader() });
  return res.data;
};

export const deleteCardapio = async (id) => {
  await api.delete(`/cardapio/cardapios/${id}`, { headers: authHeader() });
};

// traduções de cardápio (usadas no PublicMenu.jsx)
export const listCardapioTraducoes = async (cardapioId) => {
  const res = await api.get(`/cardapio/cardapios/${cardapioId}/traducoes`, {
    headers: authHeader(),
  });
  return res.data;
};

// ---------------- Categorias ----------------
export const listCategorias = async (cardapioId) => {
  const res = await api.get('/cardapio/categorias', {
    headers: authHeader(),
    params: { cardapioId },
  });
  return res.data;
};

export const getCategoria = async (id) => {
  const res = await api.get(`/cardapio/categorias/${id}`, { headers: authHeader() });
  return res.data;
};

export const saveCategoria = async (data) => {
  if (data.id) {
    const res = await api.put(`/cardapio/categorias/${data.id}`, data, { headers: authHeader() });
    return res.data;
  }
  const res = await api.post('/cardapio/categorias', data, { headers: authHeader() });
  return res.data;
};

export const deleteCategoria = async (id) => {
  await api.delete(`/cardapio/categorias/${id}`, { headers: authHeader() });
};

// traduções de categoria (usadas no PublicMenu.jsx)
export const listCategoriaTraducoes = async (categoriaId) => {
  const res = await api.get(`/cardapio/categorias/${categoriaId}/traducoes`, {
    headers: authHeader(),
  });
  return res.data;
};

// ---------------- Itens ----------------
export const listItens = async (categoriaId) => {
  const res = await api.get('/cardapio/itens', {
    headers: authHeader(),
    params: { categoriaId },
  });
  return res.data;
};

export const getItem = async (id) => {
  const res = await api.get(`/cardapio/itens/${id}`, { headers: authHeader() });
  return res.data;
};

export const saveItem = async (data) => {
  if (data.id) {
    const res = await api.put(`/cardapio/itens/${data.id}`, data, { headers: authHeader() });
    return res.data;
  }
  const res = await api.post('/cardapio/itens', data, { headers: authHeader() });
  return res.data;
};

export const deleteItem = async (id) => {
  await api.delete(`/cardapio/itens/${id}`, { headers: authHeader() });
};

// traduções de item (usadas no PublicMenu.jsx)
export const listItemTraducoes = async (itemId) => {
  const res = await api.get(`/cardapio/itens/${itemId}/traducoes`, {
    headers: authHeader(),
  });
  return res.data;
};

// ---------------- Tags ----------------
export const listTags = async () => {
  const res = await api.get('/cardapio/tags', { headers: authHeader() });
  return res.data;
};

export const getTag = async (id) => {
  const res = await api.get(`/cardapio/tags/${id}`, { headers: authHeader() });
  return res.data;
};

export const saveTag = async (data) => {
  if (data.id) {
    const res = await api.put(`/cardapio/tags/${data.id}`, data, { headers: authHeader() });
    return res.data;
  }
  const res = await api.post('/cardapio/tags', data, { headers: authHeader() });
  return res.data;
};

export const deleteTag = async (id) => {
  await api.delete(`/cardapio/tags/${id}`, { headers: authHeader() });
};

// Associação Item-Tag
export const listItemTags = async (itemId) => {
  const res = await api.get(`/cardapio/itens/${itemId}/tags`, { headers: authHeader() });
  return res.data;
};

export const addItemTag = async (itemId, tagId) => {
  const res = await api.post(
    `/cardapio/itens/${itemId}/tags`,
    { tag_id: tagId },
    { headers: authHeader() }
  );
  return res.data;
};

export const removeItemTag = async (itemId, tagId) => {
  await api.delete(`/cardapio/itens/${itemId}/tags/${tagId}`, { headers: authHeader() });
};

// ---------------- Catalogo iFood ----------------
export const getIfoodCatalogWorkspace = async () => {
  const res = await api.get('/ifood/catalog/workspace', { timeout: 75000 });
  return res.data;
};

export const getIfoodCatalogCategoryItems = async (categoryId) => {
  const res = await api.get(
    `/ifood/catalog/categories/${encodeURIComponent(categoryId)}/items`,
    { timeout: 70000 },
  );
  return res.data;
};

export const saveIfoodCatalogCategory = async (payload) => {
  const res = await api.post('/ifood/catalog/categories', payload);
  return res.data;
};

export const getIfoodCatalogItem = async (itemId) => {
  const res = await api.get(`/ifood/catalog/items/${encodeURIComponent(itemId)}`);
  return res.data;
};

export const uploadIfoodCatalogImage = async (image) => {
  const res = await api.post('/ifood/catalog/images', { image });
  return res.data;
};

export const saveIfoodCatalogItem = async (payload) => {
  const res = await api.put('/ifood/catalog/items', payload);
  return res.data;
};

export const updateIfoodCatalogPrices = async (updates) => {
  const res = await api.patch('/ifood/catalog/items/price', { updates });
  return res.data;
};

export const updateIfoodCatalogStatuses = async (updates) => {
  const res = await api.patch('/ifood/catalog/items/status', { updates });
  return res.data;
};

export const getIfoodCatalogBatch = async (batchId) => {
  const res = await api.get(`/ifood/catalog/batches/${encodeURIComponent(batchId)}`);
  return res.data;
};

// default export (para quem usa import default)
const service = {
  getRestaurante,
  listCardapios,
  getCardapio,
  saveCardapio,
  deleteCardapio,
  listCardapioTraducoes,

  listCategorias,
  getCategoria,
  saveCategoria,
  deleteCategoria,
  listCategoriaTraducoes,

  listItens,
  getItem,
  saveItem,
  deleteItem,
  listItemTraducoes,

  listTags,
  getTag,
  saveTag,
  deleteTag,

  listItemTags,
  addItemTag,
  removeItemTag,
  getIfoodCatalogWorkspace,
  getIfoodCatalogCategoryItems,
  getIfoodCatalogItem,
  saveIfoodCatalogCategory,
  uploadIfoodCatalogImage,
  saveIfoodCatalogItem,
  updateIfoodCatalogPrices,
  updateIfoodCatalogStatuses,
  getIfoodCatalogBatch,
};
export default service;
